import { render, staticRenderFns } from "./ContactsFlowTable.vue?vue&type=template&id=c4d5fb34&scoped=true&"
import script from "./ContactsFlowTable.vue?vue&type=script&lang=js&"
export * from "./ContactsFlowTable.vue?vue&type=script&lang=js&"
import style0 from "./ContactsFlowTable.vue?vue&type=style&index=0&id=c4d5fb34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d5fb34",
  null
  
)

export default component.exports